import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { NgResponse } from '../ng-response';

import { HttpErrorHandler } from '../../services/http-error-handler';
import { HttpClientService } from '../../services/http-client.service';

import { NewsAnnouncement } from './news-announcements.model';

@Injectable()
export class NewsAnnouncementsService extends HttpClientService {
  constructor(
    readonly httpClient: HttpClient,
    readonly httpErrorHandler: HttpErrorHandler) {
    super('NewsAnnouncementsViewService', httpClient, httpErrorHandler);
  }

  fetch(): Observable<NgResponse<NewsAnnouncement[]>> {
    return this.get<NewsAnnouncement[]>('NewsAnnouncements', 'api/NewsAnnouncements');
  }
}
